import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

/**
 * Renders one Select per active dimension. Tenant-configurable
 * dimensions (job, cost code, department, etc.) — the shape is
 * `{id, key, label, required, values: [{id, code, label}]}`.
 *
 * Controlled component:
 *   - `values` is a map of `{ dimensionKey: valueId }`
 *   - `onChange(key, valueId)` fires when the user picks a value
 */
export function DimensionSelector({ dimensions, values, onChange }) {
  if (!dimensions || dimensions.length === 0) return null;
  return (
    <>
      {dimensions.map((d) => (
        <div key={d.id} className="space-y-2" data-testid={`dim-selector-${d.key}`}>
          <Label>
            {d.label}
            {d.required && <span className="text-destructive">*</span>}
          </Label>
          <Select
            value={values[d.key] || ""}
            onValueChange={(v) => onChange(d.key, v)}
          >
            <SelectTrigger data-testid={`clock-in-dim-${d.key}`}>
              <SelectValue placeholder={`Select ${d.label.toLowerCase()}`} />
            </SelectTrigger>
            <SelectContent>
              {d.values.map((v) => (
                <SelectItem key={v.id} value={v.id}>
                  {v.code} — {v.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      ))}
    </>
  );
}
